<template>
  <va-create-layout>
    <robot-form :title="title" :item="item"></robot-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"]
};
</script>
